export default function SupplierFinancialManagement() {

  return (
      <p>مدیریت مالی</p>
  );
};